import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import {
  AccompanyingVisit,
  AccompanyingVisitComment,
  AccompanyingVisitDetailParams,
  AccompanyingVisitListParams
} from '@/typings/api/yuntuSales'

/**
 * **************************************  **************************************
 */
// 分页查询陪访记录列表
export function accompanyingVisitList(data: AccompanyingVisitListParams) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/accompanyRecords/page', data)
}

// 查询陪访记录详情
export function accompanyingVisitDetail(id: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/accompanyRecords/detail', id)
}

// 删除陪访记录
export function accompanyingVisitDelete(data: AccompanyingVisitDetailParams) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/accompanyRecords/delete', data)
}

// 新增陪访记录
export function accompanyingVisitCreate(data: AccompanyingVisit) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/accompanyRecords/create', data)
}

// 修改陪访记录
export function accompanyingVisitUpdate(data: AccompanyingVisit) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/accompanyRecords/update', data)
}

// 评论陪访记录
export function accompanyingVisitComment(data: AccompanyingVisitComment) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/accompanyRecords/comment/create', data)
}

// 删除陪访记录评论
export function accompanyingVisitCommentDelete(id: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/accompanyRecords/comment/delete', id)
}

// 根据线索\客户id查询跟进记录列表
export function getFollowListByRefId(refId: string) {
  return request.get<AxiosResult, AxiosResult>(`/lbu/api/followRecords/selectListByRefId/${refId}`)
}
